import { useQuery } from '@tanstack/react-query';
import { shopifyApi } from 'services';
import type { ImportProductsRequest, ImportProductsResponse } from 'services/shopifyApi';

interface UseShopifyProductsParams extends ImportProductsRequest {
  enabled?: boolean;
}

export const useShopifyProducts = (params: UseShopifyProductsParams = {}) => {
  const { enabled = true, ...requestParams } = params;

  return useQuery<ImportProductsResponse>({
    queryKey: ['shopify', 'products', requestParams],
    queryFn: () => shopifyApi.importProducts(requestParams),
    enabled,
    staleTime: 30000, // 30 seconds
  });
};